import { StatDto } from '../../../models/dtos/stat.dto';
import axios from '../../axios';

export default async function getStatRequest() {
  const response = await axios.get<StatDto>(
    `${process.env.REACT_APP_BASE_URL}/users/stat`
  );
  return response.data;
}
